/* eslint-disable react-hooks/exhaustive-deps */
// import TicketMenuManagementCreate from "./lib/create";
import { useEffect, useRef } from 'react';
import SurveyCreateQuestions from '../lib/questions';
import Gap from 'components/gap';
import { useTypedSelector } from 'common/hooks/useTypedSelector';
import SurveyCreateFormInfo from '../lib/info';
import { useActions } from 'common/hooks/useActions';
import AppLoading from 'components/appLoading';
import PrimaryButton from 'components/form/buttons/primaryButton';

import * as S from './styles';

export default function SurveyCreatePage() {
  const { ticketDetail } = useTypedSelector((state) => state.Tickets);
  const { questions, surveyCreate } = useTypedSelector((state) => state.Survey);
  const { surveyQuestionListAction } = useActions();

  const formRef = useRef<{ submitForm: () => void } | null>(null);

  useEffect(() => {
    surveyQuestionListAction([]);
  }, []);

  return (
    <S.Container>
      <S.Head>
        <S.Title>Create New Survey</S.Title>
      </S.Head>
      <Gap size="20px" />
      <S.Div className="row">
        <S.Div className="col-md-12">
          <SurveyCreateFormInfo ref={formRef} questions={questions} />
        </S.Div>
        <S.Div className="col-md-12">
          <SurveyCreateQuestions data={ticketDetail.data} questions={questions} isUpdate={false} />
        </S.Div>

        <div>
          <PrimaryButton
            onClick={() => formRef.current?.submitForm()}
            style={{ borderRadius: 10, marginRight: 'auto' }}
          >
            Create Survey
          </PrimaryButton>
        </div>
      </S.Div>

      <AppLoading loading={surveyCreate.loading} />
    </S.Container>
  );
}
